import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
const LogoHeader = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "header-logo" },
        React.createElement("a", { href: window.homeurl, "data-analytics": '{"event": "click", "eventCategory": "__pageCategory__", "eventAction": "click logo"}' },
            React.createElement(Logo, { context: 'header', id: "main", title: t('global.homepage') }))));
};
export default LogoHeader;
